import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const AppointmentCard = ({ appointment, onStatusUpdate, onNavigate, onCall, isActive }) => {
  const urgencyColors = {
    urgent: 'border-l-4 border-l-error bg-error/5',
    today: 'border-l-4 border-l-warning bg-warning/5',
    scheduled: 'border-l-4 border-l-primary bg-primary/5'
  };

  const statusIcons = {
    planned: 'Clock',
    en_route: 'Navigation',
    on_site: 'MapPin',
    completed: 'CheckCircle'
  };

  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('fr-FR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className={`bg-card rounded-lg p-4 mb-3 transition-all duration-200 ${urgencyColors?.[appointment?.urgency]} ${isActive ? 'ring-2 ring-primary shadow-md' : 'hover:shadow-sm'}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <Image
            src={appointment?.customerAvatar}
            alt={appointment?.customerAvatarAlt}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <h3 className="font-semibold text-foreground">{appointment?.customerName}</h3>
            <p className="text-sm text-muted-foreground">{appointment?.serviceType}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name={statusIcons?.[appointment?.status]} size={20} className="text-primary" />
          

          {appointment?.status === 'on_site' ? (
            <span className="text-sm font-medium text-foreground capitalize">En cours</span>
          ) : appointment?.status === 'planned' ? (
            <span className="text-sm font-medium text-foreground capitalize">Planifié</span>
          ): appointment?.status === 'en_route' ? (
            <span className="text-sm font-medium text-foreground capitalize">En route</span>
          ) : appointment?.status === 'completed' ? (
            <span className="text-sm font-medium text-foreground capitalize">Terminé</span>
          ) : null}
          {/* <span className={`text-xs font-medium px-2 py-1 rounded-full ${
            appointment?.urgency === 'urgent' ? 'bg-error/10 text-error' :
            appointment?.urgency === 'today'? 'bg-warning/10 text-warning' : 'bg-primary/10 text-primary'
          }`}>
            {appointment?.urgency === 'urgent' ? 'Urgent' : 
             appointment?.urgency === 'today'? "Aujourd'hui" : 'Planifié'}
          </span> */}
        </div>
      </div>
      <div className="space-y-2 mb-3">
         <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Calendar" size={16} />
          <span>{appointment?.scheduleddate}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>{appointment?.scheduledTime} - {appointment?.estimatedDuration}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="MapPin" size={16} />
          <span className="line-clamp-1">{appointment?.address}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Phone" size={16} />
          <span>{appointment?.phone}</span>
        </div>
      </div>
      {appointment?.notes && (
        <div className="bg-muted/50 rounded p-2 mb-3">
          <p className="text-xs text-muted-foreground">{appointment?.notes}</p>
        </div>
      )}
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Navigation"
          onClick={() => onNavigate(appointment)}
          className="flex-1"
        >
          Naviguer
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Phone"
          onClick={() => onCall(appointment)}
          className="flex-1"
        >
          Appeler
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="ArrowRight"
          onClick={() => onStatusUpdate(appointment)}
          className="flex-1"
          disabled={appointment?.status === 'completed'}
        >
          Démarrer
        </Button>
      </div>
    </div>
  );
};

export default AppointmentCard;